import { useCallback } from "react";
import { useAppDispatch } from "../../../../../../../redux";
import { getBenefitMediaViewUrlSagaAction } from "../../../../../../../redux/saga/partner-program/benefits-log/saga-actions";
import { BenefitLogFile } from "./mockData";

const useBenefitMediaPreview = (onError?: (message: string) => void) => {
  const dispatch = useAppDispatch();

  return useCallback(
    (file: BenefitLogFile) => {
      if (file.file instanceof File) {
        const objectUrl = URL.createObjectURL(file.file);
        window.open(objectUrl, "_blank", "noopener,noreferrer");
        window.setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
        return;
      }
      if (!file.filePath) return;

      // Open synchronously so the browser treats it as user-initiated, not a blocked popup.
      const previewTab = window.open("", "_blank");
      dispatch(
        getBenefitMediaViewUrlSagaAction({
          fileKey: file.filePath,
          onSuccess: (url) => {
            if (previewTab) {
              previewTab.opener = null;
              previewTab.location.href = url;
            } else {
              window.open(url, "_blank", "noopener,noreferrer");
            }
          },
          onError: (message) => {
            previewTab?.close();
            onError?.(message || "Unable to open file preview.");
          },
        })
      );
    },
    [dispatch, onError]
  );
};

export default useBenefitMediaPreview;
